export const CanaryUsers: Readonly<string[]> = [
    // "bee6c061-74a9-4c49-809a-1d1275968e70", // Justin van Ryneveld
    // "922a8a19-0f74-4e1a-b2e6-5e65b4e23655", // Nicholas Freeland
    // "8d74493e-89e5-40ce-b020-16724bc81109", // Mike Babbage
    // "2504bac4-b498-4c38-bae7-3a8b6df66c6b", // Ziggy Wegner
    // "2a0f44ef-1d59-486b-a5e2-1e08efc7bb6a", // Sharon You
    // "41fc6dd0-de57-4398-96c1-091200968196", // Fujia Luo
    // "526952b6-b165-463d-80e5-44d19ea50ee5", // Ben Coop
    // "67950ee2-4280-4c07-8525-4f16ffe4068f", // Ye Lee
    // "e5b3c273-c491-422f-8072-702995b6460e", // Eddy Dalton
    // "a764ca66-f539-4b10-b2ee-499e85701dce", // Aaron Hsieh
    // "9751107c-13bc-4a17-b1eb-4b1504cb0d37", // Will Liu
    // "f0932af1-2fcb-4a6a-a336-c11e36eddcd0", // Mo Moussa
    // "ab875ae9-692c-425b-9687-16f2b17b9e62", // Hub
    // "a47403c1-d82d-43e7-a3b4-0729a4ed160a", // André Pereria
    // "19f07701-b677-4c61-b269-834522d3bb08", // Joanna Wojceichowska
    // "1ae6f91b-efca-4093-abf4-5221db29d41a", // Luci Scherr
    // "25cf5cca-3e6a-41ef-802a-849864e5661e", // Geoff Bills
    // "b5633a21-74e3-42d0-a208-2d69ff5de8af", // Magda Szlendak
    // "cf28272a-dda4-469b-99ac-cf79b01d9235", // Jason Soon
    // "cc0f4a06-08e5-4421-88bd-7b823014e92a", // Eithan Abdullah
    // "5b3aed47-c367-4314-8bea-538fd49423ca", // Jaroslaw Duda
    // "d95e387d-0588-4471-8178-1614f89c5295", // Pete de Vroom
]